/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import { Icon, Button, Generic } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const INSPECTION_CODES_COLUMNS = [
  {
    Header: "Inspection Description",
    accessor: "InspectionCode.CodeDescription",
    id: "InspectionCode"
  },
  {
    Header: "Vehicle Type",
    accessor: "VehicleType.CodeDescription",
    id: "VehicleType"
  },
  {
    Header: "Odometer Reading Required",
    accessor: "OdometerReq",
    id: "OdometerReq",
    Cell: ({ cell }) => (cell.value ? "Yes" : "No")
  },
  {
    Header: "Active",
    accessor: "Active",
    Cell: ({ cell }) => (cell.value ? "Yes" : "No")
  }
];

export const INSPECTION_MASTER_COLUMNS = handleEdit => [
  {
    Header: "Inspection Description",
    accessor: "InspectionCode.CodeDescription",
    id: "InspectionCode"
  },
  {
    Header: "Vehicle Type",
    accessor: "VehicleType.CodeDescription",
    id: "VehicleType"
  },
  {
    Header: "Odometer Reading Required",
    accessor: "OdometerReq",
    id: "OdometerReq",
    Cell: ({ cell }) => (cell.value ? "Yes" : "No")
  },
  {
    Header: "Active",
    accessor: "Active",
    Cell: ({ cell }) => (cell.value ? "Yes" : "No")
  },
  {
    Header: "Edit",
    accessor: "Edit",
    maxWidth: "5%",
    Cell: ({ row }) => (
      <Generic style={{ textAlign: "center" }} type="button">
        <Button
          color="primary"
          size="small"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            handleEdit(row.original);
          }}
        >
          <Icon>
            <FontAwesomeIcon icon="pencil-alt" />
          </Icon>
        </Button>
      </Generic>
    )
  }
];

export const INSPECTION_COLUMNS = [
  {
    Header: "Line Item",
    accessor: "LineItem",
    id: "LineItem"
  },
  {
    Header: "Description",
    accessor: "Description",
    id: "Description"
  },
  {
    Header: "Active",
    accessor: "Active",
    Cell: ({ cell }) => (cell.value ? "Yes" : "No")
  }
];
